import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Rocket, Target } from "lucide-react";
import { WHY_BOOSTF } from "@/constants/content";

const ICONS = [GraduationCap, Rocket, Target];

const WhyBoostF = () => (
  <section id="why" className="section-pad relative">
    <div className="container-x">
      <div className="max-w-3xl">
        <div className="chip">Why BoostF</div>
        <h2 className="mt-3 font-display font-bold tracking-tight text-slate-900" style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)", letterSpacing: "-0.02em" }}>
          Built for people who want to actually launch — <span className="gradient-text-emerald">not just learn</span>.
        </h2>
      </div>

      <div className="mt-10 grid gap-5 md:grid-cols-3">
        {WHY_BOOSTF.map((c, i) => {
          const Icon = ICONS[i] || GraduationCap;
          return (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative rounded-3xl bg-white p-6 sm:p-7 border border-slate-100 shadow-premium overflow-hidden"
            >
              <div
                aria-hidden
                className="absolute -top-24 -right-24 w-56 h-56 rounded-full blur-3xl opacity-0 group-hover:opacity-60 transition-opacity"
                style={{ background: i % 2 ? "hsl(var(--lime) / 0.4)" : "hsl(var(--emerald-500) / 0.35)" }}
              />
              <div className="text-[11px] font-mono uppercase tracking-widest text-emerald-700">
                {c.kicker}
              </div>
              <div className="mt-4 flex items-start justify-between gap-4">
                <h3 className="font-display font-bold text-2xl text-slate-900 leading-tight">{c.title}</h3>
                <div className="w-11 h-11 rounded-2xl grid place-items-center bg-emerald-50 text-emerald-700 border border-emerald-100">
                  <Icon className="w-5 h-5" />
                </div>
              </div>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">{c.body}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhyBoostF;
